export const paymentConstants = {
  GET_PAYMENT_REQUEST: "GET_PAYMENT_REQUEST",
  GET_PAYMENT_SUCCESS: "GET_PAYMENT_SUCCESS",
  PAYMENT_CLEAR: "PAYMENT_CLEAR"
};
